import { render, staticRenderFns } from "./CertificatesFilter.vue?vue&type=template&id=d0080118&scoped=true"
import script from "./CertificatesFilter.vue?vue&type=script&lang=js"
export * from "./CertificatesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0080118",
  null
  
)

export default component.exports